import React, { useState } from 'react';
import PayoutDialogShell, { labelCss, inputCss, errorCss, primaryBtn, secondaryBtn } from './PayoutDialogShell';
import PayeeUpiPanel from './PayeeUpiPanel';
import { markSessionPayoutLinesPaid } from '../../utils/api';
import {
  PAYMENT_MODE_LABELS, fmtRupees, textValid, todayStr, startOfDayISO, actionErrorMessage, isStaleCode,
} from '../../utils/payoutFormat';

// Record a payment the admin already made outside the app, for released lines of ONE healer.
const MarkPaidDialog = ({ healerId, healerName, upiId, hasBankDetails, lines, onClose, onDone }) => {
  const [mode,  setMode]  = useState('upi');
  const [ref,   setRef]   = useState('');
  const [paidOn, setPaidOn] = useState(todayStr());
  const [busy,  setBusy]  = useState(false);
  const [error, setError] = useState('');
  const totalPaise = lines.reduce(function(sum, l) { return sum + (l.amount || 0); }, 0);
  const valid = textValid(ref, 3, 100) && !!paidOn && paidOn <= todayStr();

  const submit = async function() {
    if (busy || !valid) return;
    setBusy(true);
    setError('');
    try {
      const res = await markSessionPayoutLinesPaid({
        healerId,
        lineIds:          lines.map(function(l) { return l._id; }),
        paymentMode:      mode,
        paymentReference: ref.trim(),
        paidAt:           startOfDayISO(paidOn),
      });
      const paid = res.data.data.paidCount;
      const skipped = lines.length - paid;
      onDone(skipped > 0
        ? paid + ' paid, ' + skipped + ' skipped because they changed.'
        : paid + (paid === 1 ? ' line' : ' lines') + ' marked as paid.', skipped > 0);
    } catch (err) {
      const code = err.response && err.response.data && err.response.data.code;
      if (isStaleCode(code)) onDone(actionErrorMessage(err, ''), true);
      else setError(actionErrorMessage(err, 'Something went wrong. Please try again.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PayoutDialogShell title="Mark as paid" onClose={onClose} busy={busy}>
      <p style={{ margin: '0 0 8px', fontSize: 13, color: '#374151' }}>
        Record a payment you have already made outside the app. LifeChiAI does not send the money.
      </p>
      <div style={{ fontSize: 14, color: '#111827', fontWeight: 600 }}>
        {healerName} · {lines.length} {lines.length === 1 ? 'session' : 'sessions'} · {fmtRupees(totalPaise)}
      </div>
      <PayeeUpiPanel upiId={upiId} hasBankDetails={hasBankDetails} />
      <label style={labelCss} htmlFor="paid-mode">Payment mode</label>
      <select id="paid-mode" value={mode} onChange={function(e) { setMode(e.target.value); }} style={inputCss} disabled={busy}>
        {Object.keys(PAYMENT_MODE_LABELS).map(function(k) { return <option key={k} value={k}>{PAYMENT_MODE_LABELS[k]}</option>; })}
      </select>
      <label style={Object.assign({}, labelCss, { marginTop: 12 })} htmlFor="paid-ref">Reference / UTR (3–100 characters)</label>
      <input id="paid-ref" type="text" value={ref} maxLength={100} style={inputCss} disabled={busy}
        onChange={function(e) { setRef(e.target.value); }} />
      <label style={Object.assign({}, labelCss, { marginTop: 12 })} htmlFor="paid-on">Paid on</label>
      <input id="paid-on" type="date" value={paidOn} max={todayStr()} style={inputCss} disabled={busy}
        onChange={function(e) { setPaidOn(e.target.value); }} />
      {error && <div style={errorCss}>{error}</div>}
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
        <button style={secondaryBtn} onClick={onClose} disabled={busy}>Close</button>
        <button style={primaryBtn(!valid || busy)} onClick={submit} disabled={!valid || busy}>
          {busy ? 'Saving…' : 'Mark as paid'}
        </button>
      </div>
    </PayoutDialogShell>
  );
};

export default MarkPaidDialog;
